import { FlashcardContent } from '../types/Flashcard';
import { ImageType } from '../types/Image';
import { VignetteContent } from '../types/Vignette';

type ContentImageLink = {
  contextSpecificCaption: string | null;
  isExhibit?: boolean;
  ord: number | null;
  image: ImageType;
};

const compareNullableOrd = (
  leftOrd?: number | null,
  rightOrd?: number | null
): number => {
  if (leftOrd == null && rightOrd == null) {
    return 0;
  }
  if (leftOrd == null) {
    return 1;
  }
  if (rightOrd == null) {
    return -1;
  }
  return leftOrd - rightOrd;
};

export const getDisplayImagesFromImageLinks = (
  imageLinks: ContentImageLink[]
): ImageType[] =>
  [...imageLinks]
    .sort((left, right) => compareNullableOrd(left.ord, right.ord))
    .map((imageLink) => ({
      ...imageLink.image,
      caption: imageLink.contextSpecificCaption ?? imageLink.image.caption,
      ord: imageLink.ord ?? imageLink.image.ord ?? null,
    }));

export const getDisplayImagesFromContent = (
  content: FlashcardContent | VignetteContent
): ImageType[] => {
  if (Array.isArray(content.imageLinks) && content.imageLinks.length > 0) {
    return getDisplayImagesFromImageLinks(content.imageLinks);
  }
  if (Array.isArray(content.Image) && content.Image.length > 0) {
    return [...content.Image];
  }
  return [];
};

export const getExhibitDisplayImagesFromContent = (
  content: FlashcardContent | VignetteContent | undefined
): ImageType[] => {
  if (!content || !Array.isArray(content.imageLinks)) {
    return [];
  }
  return getDisplayImagesFromImageLinks(
    content.imageLinks.filter((imageLink) => imageLink.isExhibit)
  );
};
